import { useState, useEffect } from 'react';
import { medicosAPI } from '../../../core/api/api';

const useHorarioMedico = (idHorarioMedico) => {
  const [formData, setFormData] = useState({
    idHorarioMedico: null,
    idCentro: '',
    tipoMedico: '2',
    idMedico: '',
    fechaDesde: '',
    horaDesde: '00',
    minutosDesde: '00',
    fechaHasta: '',
    horaHasta: '00',
    minutosHasta: '00',
    dias: [],
    observacion: ''
  });

  useEffect(() => {
    const convertirFecha = (fecha) => {
      if (!fecha) return '';
      const partes = fecha.split('/');
      if (partes.length === 3) {
        return `${partes[2]}-${partes[1]}-${partes[0]}`;
      }
      return fecha;
    };

    const cargarHorario = async () => {
      if (!idHorarioMedico) {
        setFormData({
          idHorarioMedico: null,
          idCentro: '',
          tipoMedico: '2',
          idMedico: '',
          fechaDesde: '',
          horaDesde: '00',
          minutosDesde: '00',
          fechaHasta: '',
          horaHasta: '00',
          minutosHasta: '00',
          dias: [],
          observacion: ''
        });
        return;
      }

      try {
        const response = await medicosAPI.obtenerHorarioMedico(idHorarioMedico);
        const data = response.data;
        setFormData({
          idHorarioMedico: data.idHorarioMedico,
          idCentro: data.idCentro || '',
          tipoMedico: data.tipoMedico?.toString() || '2',
          idMedico: data.idMedico || '',
          fechaDesde: convertirFecha(data.fechaIni),
          horaDesde: data.horaIni || '00',
          minutosDesde: data.minutosIni || '00',
          fechaHasta: convertirFecha(data.fechaFin),
          horaHasta: data.horaFin || '00',
          minutosHasta: data.minutosFin || '00',
          dias: [],
          observacion: data.observacion || ''
        });
      } catch (error) {
        console.error('Error al cargar horario:', error);
      }
    };

    cargarHorario();
  }, [idHorarioMedico]);

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    
    if (name === 'dias') {
      const dia = parseInt(value);
      setFormData(prev => ({
        ...prev,
        dias: checked 
          ? [...prev.dias, dia]
          : prev.dias.filter(d => d !== dia)
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    try {
      if (formData.idHorarioMedico) {
        await medicosAPI.actualizarHorarioMedico(formData);
      } else {
        await medicosAPI.agregarHorarioMedico(formData);
      }
      return true;
    } catch (error) {
      console.error('Error al guardar horario:', error);
      return false;
    }
  };

  const handleDelete = async () => {
    try {
      await medicosAPI.eliminarHorarioMedico(formData.idHorarioMedico);
      return true;
    } catch (error) {
      console.error('Error al eliminar horario:', error);
      return false;
    }
  };

  return { formData, handleChange, handleSubmit, handleDelete };
};

export default useHorarioMedico;
